






import { BrowserModule } from '@angular/platform-browser';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';

import { AppComponent } from './app.component';

import { InterventionsModule } from './interventions/interventions.module';

import { registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr';

import { CoreModule } from './core/core.module';
import { AppRoutingModule } from './app-routing.module';
import { NgxPermissionsModule } from 'ngx-permissions';
import { AvailabilityModule } from './availability/availability.module';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';





// the second parameter 'fr' is optional
registerLocaleData(localeFr, 'fr');

@NgModule({
  declarations: [
    AppComponent,

  ],
  imports: [
    CoreModule,
    AppRoutingModule,
    InterventionsModule,
    AvailabilityModule,
    BrowserModule,
    MatProgressSpinnerModule,
    BrowserAnimationsModule,





  ],
  // providers: [
  //   { provide: LOCALE_ID, useValue: 'fr' },
  // ],
  bootstrap: [AppComponent]
})
export class AppModule { }
